import React, { lazy, Suspense } from 'react';

import type { CookieCompliancePopupProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/GoogleConsentCookieBanner/types';

const Cookie: React.FC<CookieCompliancePopupProps> = lazy(
  () => new Promise<typeof import('./index.lazy')>((resolve) => {
    setTimeout(() => {
      resolve(import('./index.lazy'));
    }, 1500);
  }),
);

const CookieSuspense: React.FC<CookieCompliancePopupProps> = (props) => (
  <Suspense fallback={<div />}>
    <Cookie {...props} />
  </Suspense>
);

export default CookieSuspense;
